import { render } from "./App.vue?vue&type=template&id=4f8a5536"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4f8a5536&lang=less"

import exportComponent from "G:\\Teamax\\雅丽洁支付\\yalgetoms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__